import EventEmitter, { MessageFn as defaultMessageFnType } from '@utils/eventEmitter';
import { StudentTestletSessionStatus, TestletSessionTimeSettings } from '../types';

export interface TestletNotificationPayload {
  testlet_id: number;
  user_id: number;
  timestamp: string;
  testlet_name: string;
  lock_strategy: string;
  section_id: number;
  test_session_id: number;
}

export interface TestletSessionTimeExtendedNotificationPayload
  extends TestletNotificationPayload {
  testlet_session_id: number;
  time_settings: TestletSessionTimeSettings;
}
export interface TestletSessionCompletedNotificationPayload
  extends TestletNotificationPayload {
  testlet_session_id: number;
  status: StudentTestletSessionStatus;
  max_score: number;
  score: number;
  completed_at: string;
  started_at: string;
}

export interface TestletSessionStateUpdateNotificationPayload
  extends TestletNotificationPayload {
  testlet_session_id: number;
  status: StudentTestletSessionStatus;
  course_id: string;
}

export interface TestletSessionActivityNotificationPayload
  extends TestletNotificationPayload {
  testlet_session_id: number;
  event_type: string;
  metadata: any;
}

export interface ExamReportCsvCompletedPayload {
  report_name: string;
  report_url: string;
}

export interface ExamReportCsvFailedPayload {
  report_name: string;
  error: string;
}

export enum LearnosityExamsEvents {
  TESTLET_UNLOCKED = 'TESTLET_UNLOCKED',
  TESTLET_LOCKED = 'TESTLET_LOCKED',
  TESTLET_SESSION_IN_PROGRESS = 'TESTLET_SESSION_IN_PROGRESS',
  TESTLET_SESSION_PAUSED = 'TESTLET_SESSION_PAUSED',
  TESTLET_SESSION_COMPLETED = 'TESTLET_SESSION_COMPLETED',
  TESTLET_SESSION_RESET = 'TESTLET_SESSION_RESET',
  TESTLET_SESSION_TIME_EXTENDED = 'TESTLET_SESSION_TIME_EXTENDED',
  TESTLET_FOCUSED = 'TESTLET_FOCUSED',
  TESTLET_UNFOCUSED = 'TESTLET_UNFOCUSED',
  TESTLET_INACTIVE = 'TESTLET_INACTIVE',
  EXAM_REPORT_CSV_COMPLETED = 'EXAM_REPORT_CSV_COMPLETED',
  EXAM_REPORT_CSV_FAILED = 'EXAM_REPORT_CSV_FAILED',
}

type LearnosityExamsEventEmitterType = {
  [LearnosityExamsEvents.TESTLET_UNLOCKED]: TestletNotificationPayload;
  [LearnosityExamsEvents.TESTLET_LOCKED]: TestletNotificationPayload;
  [LearnosityExamsEvents.TESTLET_SESSION_IN_PROGRESS]: TestletSessionStateUpdateNotificationPayload;
  [LearnosityExamsEvents.TESTLET_SESSION_PAUSED]: TestletSessionStateUpdateNotificationPayload;
  [LearnosityExamsEvents.TESTLET_SESSION_COMPLETED]: TestletSessionCompletedNotificationPayload;
  [LearnosityExamsEvents.TESTLET_SESSION_RESET]: TestletSessionStateUpdateNotificationPayload;
  [LearnosityExamsEvents.TESTLET_SESSION_TIME_EXTENDED]: TestletSessionTimeExtendedNotificationPayload;
  [LearnosityExamsEvents.TESTLET_FOCUSED]: TestletSessionActivityNotificationPayload;
  [LearnosityExamsEvents.TESTLET_UNFOCUSED]: TestletSessionActivityNotificationPayload;
  [LearnosityExamsEvents.TESTLET_INACTIVE]: TestletSessionActivityNotificationPayload;
  [LearnosityExamsEvents.EXAM_REPORT_CSV_COMPLETED]: ExamReportCsvCompletedPayload;
  [LearnosityExamsEvents.EXAM_REPORT_CSV_FAILED]: ExamReportCsvFailedPayload;
};
export type MessageFnType = defaultMessageFnType<LearnosityExamsEventEmitterType>;

const LearnosityExamsEventEmitter = new EventEmitter<LearnosityExamsEventEmitterType>();
export default LearnosityExamsEventEmitter;
